// extracted by mini-css-extract-plugin
module.exports = {"text":"h1_text__4ur2z font_h1__5p3MT layout_internalMarginBottom__2MazN","h1":"h1_h1__29yTB"};